/*
 *
 * Audiences actions
 *
 */

import {
  FLUSH_STATE_AUDIENSES,
  // load items list
  LOAD_AUDIENSES,
  LOAD_AUDIENSES_SUCCESS,
  LOAD_AUDIENSES_ERROR,
} from './constants';

/**
 * Clearing the state for Audiences
 */
export function flushStateAudiences() {
  return {
    type: FLUSH_STATE_AUDIENSES,
  };
}

/**
 * ------------------ LOAD ------------------
 */

/**
 * Load the Audiences, this action starts the request saga
 *
 * @return {array} An action object with a type of LOAD_AUDIENSES
 */
export function loadAudiences(params, firstRender = false) {
  return {
    type: LOAD_AUDIENSES,
    params,
    firstRender
  };
}

/**
 * Dispatched when the loadAudiences are loaded by the request saga
 *
 * @param  {array} variables true for Audiences
 *
 * @return {array} An action object with a type of LOAD_AUDIENSES_SUCCESS passing the variables
 */
export function loadAudiencesSuccess(allData, itemsList, params) {
  return {
    type: LOAD_AUDIENSES_SUCCESS,
    allData,
    itemsList,
    params,
  };
}

/**
 * Dispatched when loading the loadAudiences fails
 *
 * @param  {object} error The error
 *
 * @return {object} An action object with a type of LOAD_AUDIENSES_ERROR passing the error
 */
export function loadAudiencesError(error) {
  return {
    type: LOAD_AUDIENSES_ERROR,
    error,
  };
}